/** Query keys for ingestion rules, scoped per org like every other domain. */
export const ingestionRulesQueryKeys = {
  all: (orgId: string) => ["ingestionRules", orgId] as const,
  list: (orgId: string) =>
    [...ingestionRulesQueryKeys.all(orgId), "list"] as const,
  defaults: (orgId: string) =>
    [...ingestionRulesQueryKeys.all(orgId), "defaults"] as const,
  byId: (orgId: string, ruleId: string) =>
    [...ingestionRulesQueryKeys.all(orgId), "byId", ruleId] as const,
  matching: (orgId: string, path: string) =>
    [...ingestionRulesQueryKeys.all(orgId), "matching", path] as const,
  matchingAny: (orgId: string, paths: readonly string[]) =>
    [...ingestionRulesQueryKeys.all(orgId), "matchingAny", ...paths] as const,
  latestRuns: (orgId: string, fileIds: readonly string[]) =>
    [...ingestionRulesQueryKeys.all(orgId), "latestRuns", ...fileIds] as const,
  existingFiles: (orgId: string, ruleId: string) =>
    [...ingestionRulesQueryKeys.all(orgId), "existingFiles", ruleId] as const,
};
